module.exports = __webpack_public_path__ + "img/intimate.8ba87a3.svg";